/**
 * Route composition by host surface. Owner: foundation (ui-shell may request changes).
 * portal.* -> customer, partners.* -> partners, admin.* -> admin. Localhost defaults to customer.
 * Customer sign-in / sign-up are standalone pages (AuthLayout): they never render inside the portal shell.
 */
import type { RouteObject } from 'react-router';
import type { Surface } from '@qm/tenancy/surface';
import { Shell } from '../shell/Shell';
import { AuthLayout } from '../shell/AuthLayout';
import { NotFoundScreen, RouteErrorScreen } from '../shell/RouteStates';
import { customerAuthRoutes, customerRoutes } from './customer';
import { partnerRoutes } from './partners';
import { adminRoutes } from './admin';

export function routesForSurface(surface: Surface): RouteObject[] {
  const children = surface === 'partner' ? partnerRoutes : surface === 'admin' ? adminRoutes : customerRoutes;
  const s = surface === 'partner' || surface === 'admin' ? surface : 'customer';
  // catch-all + errorElement: unknown paths and crashing screens get the branded, translated states (QM-D02-003)
  const shell: RouteObject = { path: '/', element: <Shell surface={s} />, errorElement: <RouteErrorScreen surface={s} />, children: [...children, { path: '*', element: <NotFoundScreen /> }] };
  if (s !== 'customer') return [shell];
  return [shell, { element: <AuthLayout />, errorElement: <RouteErrorScreen surface="customer" />, children: customerAuthRoutes }];
}
